import { cva, type VariantProps } from 'class-variance-authority';

import { cx } from '@/lib/cx';

/** Variantes visuais dos primitivos — separadas dos componentes para reuso (ex.: Link com cara de botão). */
export const estiloBotao = cva(
  [
    'inline-flex shrink-0 select-none items-center justify-center gap-2 whitespace-nowrap font-medium',
    'rounded-controle transition-[background-color,box-shadow,transform,color] duration-[var(--duracao-rapida)]',
    // Mãozinha no clicável, bloqueio no desabilitado e espera no carregando: o Tailwind 4 deixou o
    // botão com a seta padrão (achado em produção, 14/10/2026).
    'cursor-pointer enabled:active:translate-y-px disabled:cursor-not-allowed disabled:opacity-50 aria-busy:cursor-wait',
    '[&_svg]:size-4 [&_svg]:shrink-0',
  ],
  {
    variants: {
      variante: {
        primario: 'bg-marca text-marca-texto shadow-baixa enabled:hover:bg-marca-forte',
        secundario:
          'border border-borda-forte bg-superficie text-texto shadow-baixa enabled:hover:bg-superficie-hover',
        fantasma: 'text-texto-suave enabled:hover:bg-superficie-hover enabled:hover:text-texto',
        perigo: 'bg-perigo text-texto-inverso enabled:hover:opacity-90',
        link: 'h-auto px-0 text-marca underline-offset-4 hover:underline',
      },
      tamanho: {
        md: 'h-controle px-3.5 text-base',
        sm: 'h-controle-sm px-2.5 text-sm',
        icone: 'size-controle',
        'icone-sm': 'size-controle-sm',
      },
    },
    defaultVariants: { variante: 'secundario', tamanho: 'md' },
  },
);

export const estiloCampo = cx(
  'w-full rounded-controle border border-borda-forte bg-superficie px-3 text-base text-texto',
  'placeholder:text-texto-fraco shadow-baixa transition-[border-color,box-shadow] duration-[var(--duracao-rapida)]',
  'focus-visible:border-marca focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-marca-suave',
  'disabled:cursor-not-allowed disabled:opacity-60 aria-invalid:border-perigo',
);

export const estiloBadge = cva(
  'inline-flex items-center gap-1 whitespace-nowrap rounded-pilula px-2 py-0.5 text-xs font-medium [&_svg]:size-3',
  {
    variants: {
      tom: {
        neutro: 'bg-superficie-afundada text-texto-suave',
        marca: 'bg-marca-suave text-marca',
        sucesso: 'bg-sucesso-suave text-sucesso',
        perigo: 'bg-perigo-suave text-perigo',
        alerta: 'bg-alerta-suave text-alerta',
        info: 'bg-info-suave text-info',
      },
    },
    defaultVariants: { tom: 'neutro' },
  },
);

export type TomBadge = NonNullable<VariantProps<typeof estiloBadge>['tom']>;
